import React from 'react';
import { Card, CardHeader, CardContent, Typography } from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';
import StarHalfIcon from '@material-ui/icons/StarHalf';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import history from './history';
import '../styles/exercisecard.css'

const rootClass = "exercisecard root";
const titleClass = "exercisecard title";
const problemClass = "exercisecard problem";
const starConatinerClass = "exercisecard starcontainer";
const informationClass = "exercisecard information";
const informationSubClass = "exercisecard subinformation";

const limit = (str, num) => {
    if (str.length > num) {
        return str.slice(0, num - 3) + '...';
    } else {
        return str;
    }
}

const stars = (num) => {
    num = Math.max(0, Math.min(num, 5));
    num *= 2;
    num = Math.round(num);
    let r = [];
    for (let i = 0; i < 5; i++) {
        if (num >= 2) {
            r.push(<StarIcon key={i} />);
        } else if (num === 1) {
            r.push(<StarHalfIcon key={i} />);
        } else {
            r.push(<StarBorderIcon key={i} />);
        }
        num -= 2;
    }
    return <div className={starConatinerClass}>{r}</div>;
}

const averageRating = (ratings) => {
    var a = 0;
    var sum = 0;
    for (let i in ratings) {
        a += ratings[i];
        sum++;
    }
    a /= sum;
    return a;
}


class ExerciseCard extends React.Component {

    render() {
        const e = this.props.exercise;
        return (
            <>
                <Card className={rootClass} onClick={() => history.push('/exercise/' + e.id)}>
                    <CardHeader title={e.title} className={titleClass} />
                    <CardContent>
                        <Typography variant="body2" className={problemClass}>{limit(e.problem, 1024)}</Typography>
                    </CardContent>
                    <CardContent className={informationClass}>
                        {stars(averageRating(e.ratings))}
                        {!e.shown && <Typography variant="body1">Currently hidden</Typography>}
                        <div className={informationSubClass}>
                            <Typography variant="body2">{e.klassen.join(', ')}</Typography>
                            <Typography variant="body2">{new Date(parseInt(e.creationdate)).toLocaleDateString()}</Typography>
                        </div>
                    </CardContent>
                </Card>
            </>
        );
    }

}

export default ExerciseCard;